export const practiceAreas = [
  {
    id: 1,
    slug: 'corporate-law',
    title: 'Kurumsal Hukuk',
    shortDescription: 'Şirket kuruluşundan birleşme ve devralmalara kadar kapsamlı kurumsal hukuk danışmanlığı',
    icon: 'ri-building-line',
    image: 'https://public.readdy.ai/ai/img_res/c252bc20538ff0a25e947cd94019b166.jpg',
    fullDescription: 'Kurumsal hukuk pratiğimiz, yerli ve yabancı şirketlere şirket kuruluşundan günlük operasyonlara, birleşme ve devralmalardan kurumsal yeniden yapılandırmaya kadar geniş bir yelpazede hukuki danışmanlık sunmaktadır. Müvekkillerimize stratejik iş hedeflerine ulaşmalarında hukuki destek sağlıyor, risk yönetimi konusunda proaktif çözümler üretiyoruz.',
    services: [
      'Şirket kuruluşu ve yapılandırma',
      'Birleşme ve devralmalar (M&A)',
      'Kurumsal yönetim danışmanlığı',
      'Hissedar anlaşmaları',
      'Yabancı yatırımlar',
      'Kurumsal uyum programları',
      'Ortaklık yapıları ve joint venture',
      'Şirket devri ve satışı',
    ],
    commonIssues: [
      'Şirket kuruluş süreçlerinde yasal gereklilikler',
      'Yabancı yatırımcılar için Türkiye\'de şirket kurma prosedürleri',
      'Birleşme ve devralma işlemlerinde due diligence',
      'Hissedar uyuşmazlıkları ve çözüm yolları',
      'Kurumsal yönetim ilkelerine uyum',
      'Şirket içi düzenlemeler ve politikalar',
    ],
    howWeHelp: 'Deneyimli kurumsal hukuk ekibimiz, müvekkillerimizin iş hedeflerini anlayarak özelleştirilmiş hukuki çözümler sunar. Ulusal ve uluslararası düzenlemelere hakim uzmanlarımız, karmaşık kurumsal işlemlerde stratejik rehberlik sağlar. Proaktif yaklaşımımızla potansiyel riskleri önceden tespit eder, müvekkillerimizin çıkarlarını en üst düzeyde koruruz.',
  },
  {
    id: 2,
    slug: 'commercial-litigation',
    title: 'Ticari Dava',
    shortDescription: 'Ticari uyuşmazlıkların çözümünde agresif ve etkili temsil',
    icon: 'ri-scales-3-line',
    image: 'https://readdy.ai/api/search-image?query=elegant%20courtroom%20interior%20with%20wooden%20panels%20judges%20bench%20and%20professional%20legal%20setting%20serious%20atmosphere%20traditional%20law%20court%20architecture%20natural%20lighting%20premium%20judicial%20photography&width=600&height=450&seq=pa2&orientation=landscape',
    fullDescription: 'Ticari dava pratiğimiz, karmaşık ticari uyuşmazlıkların çözümünde müvekkillerimize güçlü ve stratejik temsil sağlamaktadır. Sözleşme ihlallerinden ortaklık uyuşmazlıklarına, rekabet hukukundan fikri mülkiyet davalarına kadar geniş bir alanda dava ve tahkim süreçlerinde müvekkillerimizi temsil ediyoruz.',
    services: [
      'Sözleşme ihlali davaları',
      'Ortaklık ve hissedar uyuşmazlıkları',
      'Ticari alacak takibi',
      'Rekabet hukuku davaları',
      'Fikri mülkiyet uyuşmazlıkları',
      'Tahkim ve alternatif uyuşmazlık çözümü',
      'İcra ve iflas takipleri',
      'Tazminat davaları',
    ],
    commonIssues: [
      'Sözleşme ihlallerinde tazminat talepleri',
      'Ticari alacakların tahsili',
      'Ortaklar arası uyuşmazlıkların çözümü',
      'Haksız rekabet iddiaları',
      'Ticari sırların korunması',
      'Tahkim kararlarının icrası',
    ],
    howWeHelp: 'Deneyimli dava avukatlarımız, müvekkillerimizin haklarını korumak için agresif ve stratejik bir yaklaşım benimser. Her davanın benzersiz olduğunu bilerek, özelleştirilmiş dava stratejileri geliştiririz. Mahkeme salonunda güçlü savunma ve iddia becerileriyle müvekkillerimizin çıkarlarını en üst düzeyde temsil ederiz. Alternatif uyuşmazlık çözüm yöntemlerinde de uzmanlığımızla, müvekkillerimize zaman ve maliyet tasarrufu sağlayan çözümler sunarız.',
  },
  {
    id: 3,
    slug: 'contract-law',
    title: 'Sözleşme Hukuku',
    shortDescription: 'Ticari sözleşmelerin hazırlanması, müzakeresi ve uygulanması',
    icon: 'ri-file-text-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20contract%20signing%20scene%20with%20elegant%20fountain%20pen%20on%20legal%20documents%20modern%20office%20desk%20with%20leather%20surface%20sophisticated%20business%20atmosphere%20premium%20corporate%20photography&width=600&height=450&seq=pa3&orientation=landscape',
    fullDescription: 'Sözleşme hukuku pratiğimiz, her türlü ticari sözleşmenin hazırlanması, müzakeresi ve uygulanmasında kapsamlı hukuki danışmanlık sunmaktadır. Müvekkillerimizin ticari ilişkilerini güvence altına almak, potansiyel riskleri minimize etmek ve uyuşmazlık durumlarında güçlü bir hukuki zemin oluşturmak için detaylı ve özenli çalışmalar yürütüyoruz.',
    services: [
      'Ticari sözleşme hazırlama ve müzakere',
      'Distribütörlük ve bayilik sözleşmeleri',
      'Franchise sözleşmeleri',
      'Tedarik ve hizmet sözleşmeleri',
      'Gizlilik ve rekabet yasağı anlaşmaları',
      'Lisans ve teknoloji transfer sözleşmeleri',
      'İnşaat ve yüklenici sözleşmeleri',
      'Sözleşme uyuşmazlıklarının çözümü',
    ],
    commonIssues: [
      'Sözleşme şartlarının müzakeresi',
      'Sözleşme ihlali durumunda hukuki haklar',
      'Uluslararası sözleşmelerde uygulanacak hukuk',
      'Sözleşme feshi ve sonuçları',
      'Tazminat ve ceza şartları',
      'Sözleşme değişiklikleri ve ekleri',
    ],
    howWeHelp: 'Sözleşme hukuku uzmanlarımız, müvekkillerimizin ticari hedeflerini koruyacak, hukuki riskleri minimize edecek sözleşmeler hazırlar. Her sözleşmeyi müvekkilimizin özel ihtiyaçlarına göre özelleştiriyor, karşı tarafla yapılan müzakerelerde müvekkillerimizin çıkarlarını güçlü bir şekilde savunuyoruz. Sözleşme uyuşmazlıklarında ise, sözleşme metinlerinin detaylı analizi ile müvekkillerimize en güçlü hukuki pozisyonu sağlıyoruz.',
  },
  {
    id: 4,
    slug: 'real-estate-law',
    title: 'Gayrimenkul Hukuku',
    shortDescription: 'Gayrimenkul alım-satım, kiralama ve geliştirme projelerinde uzman danışmanlık',
    icon: 'ri-home-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20modern%20real%20estate%20property%20exterior%20with%20glass%20facade%20and%20contemporary%20architecture%20high%20end%20residential%20building%20elegant%20design%20professional%20architectural%20photography%20natural%20lighting&width=600&height=450&seq=pa4&orientation=landscape',
    fullDescription: 'Gayrimenkul hukuku pratiğimiz, gayrimenkul alım-satım işlemlerinden büyük ölçekli geliştirme projelerine, kiralama sözleşmelerinden gayrimenkul finansmanına kadar geniş bir yelpazede hukuki danışmanlık sunmaktadır. Yerli ve yabancı yatırımcılara Türkiye\'deki gayrimenkul yatırımlarında stratejik rehberlik sağlıyoruz.',
    services: [
      'Gayrimenkul alım-satım işlemleri',
      'Gayrimenkul geliştirme projeleri',
      'Kat mülkiyeti ve kat irtifakı',
      'Kiralama sözleşmeleri',
      'Gayrimenkul finansmanı',
      'Tapu işlemleri ve due diligence',
      'İmar ve planlama hukuku',
      'Gayrimenkul uyuşmazlıkları',
    ],
    commonIssues: [
      'Yabancıların Türkiye\'de gayrimenkul edinimi',
      'Tapu devir işlemlerinde dikkat edilmesi gerekenler',
      'İmar durumu ve yapı ruhsatı sorunları',
      'Kiracı-ev sahibi uyuşmazlıkları',
      'Gayrimenkul üzerindeki takyidatlar',
      'Kat mülkiyeti kanunu uygulamaları',
    ],
    howWeHelp: 'Gayrimenkul hukuku ekibimiz, müvekkillerimizin gayrimenkul yatırımlarını güvence altına almak için kapsamlı hukuki inceleme ve danışmanlık hizmetleri sunar. Tapu kayıtlarının detaylı incelemesinden imar durumu analizine, sözleşme hazırlıktan devir işlemlerine kadar tüm süreçte müvekkillerimize rehberlik ederiz. Gayrimenkul uyuşmazlıklarında ise, müvekkillerimizin haklarını korumak için güçlü hukuki temsil sağlarız.',
  },
  {
    id: 5,
    slug: 'construction-law',
    title: 'İnşaat Hukuku',
    shortDescription: 'İnşaat projelerinde sözleşme yönetimi ve uyuşmazlık çözümü',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20construction%20site%20with%20steel%20framework%20and%20glass%20building%20under%20development%20professional%20architecture%20project%20contemporary%20urban%20construction%20premium%20industrial%20photography%20natural%20lighting&width=600&height=450&seq=pa5&orientation=landscape',
    fullDescription: 'İnşaat hukuku pratiğimiz, inşaat projelerinin tüm aşamalarında müteahhitlere, yüklenicilere, alt yüklenicilere ve proje sahiplerine kapsamlı hukuki danışmanlık sunmaktadır. İnşaat sözleşmelerinin hazırlanmasından uyuşmazlıkların çözümüne kadar geniş bir yelpazede hizmet veriyoruz.',
    services: [
      'İnşaat sözleşmeleri hazırlama',
      'Yüklenici ve alt yüklenici sözleşmeleri',
      'İnşaat projesi danışmanlığı',
      'Hakedişler ve ödeme uyuşmazlıkları',
      'Gecikme ve temerrüt halleri',
      'Ayıplı imalat ve kusur tespiti',
      'İnşaat sigortaları',
      'İnşaat tahkimi',
    ],
    commonIssues: [
      'İnşaat sözleşmelerinde ödeme şartları',
      'Gecikme cezaları ve tazminat talepleri',
      'Ayıplı imalat ve onarım yükümlülükleri',
      'Alt yüklenici uyuşmazlıkları',
      'İş artışı ve eksilişi hesaplamaları',
      'Kesin kabul ve garanti süreçleri',
    ],
    howWeHelp: 'İnşaat hukuku uzmanlarımız, inşaat sektörünün teknik ve hukuki karmaşıklığını bilerek, müvekkillerimize özelleştirilmiş çözümler sunar. İnşaat projelerinin başlangıcından tamamlanmasına kadar tüm aşamalarda hukuki destek sağlıyor, potansiyel uyuşmazlıkları önceden tespit ederek proaktif çözümler üretiyoruz. İnşaat uyuşmazlıklarında ise, teknik bilirkişi raporlarının analizi ve güçlü hukuki savunma ile müvekkillerimizin haklarını koruyoruz.',
  },
  {
    id: 6,
    slug: 'enforcement-bankruptcy-law',
    title: 'İcra ve İflas Hukuku',
    shortDescription: 'Alacak tahsili ve iflas süreçlerinde etkili hukuki temsil',
    icon: 'ri-auction-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20legal%20documents%20and%20gavel%20on%20elegant%20wooden%20desk%20in%20law%20office%20enforcement%20and%20bankruptcy%20legal%20papers%20serious%20judicial%20atmosphere%20premium%20legal%20photography%20natural%20lighting&width=600&height=450&seq=pa6&orientation=landscape',
    fullDescription: 'İcra ve iflas hukuku pratiğimiz, alacaklı ve borçlu haklarının korunmasında, alacak tahsili süreçlerinde ve iflas davalarında kapsamlı hukuki danışmanlık ve temsil hizmetleri sunmaktadır. Ticari alacakların tahsilinden konkordato süreçlerine kadar geniş bir alanda uzmanız.',
    services: [
      'İcra takibi başlatma ve savunma',
      'Alacak tahsili',
      'İflas davası açma ve savunma',
      'Konkordato süreçleri',
      'İhtiyati haciz ve tedbir',
      'İcra inkar tazminatı davaları',
      'Menfi tespit davaları',
      'İcra mahkemesi davaları',
    ],
    commonIssues: [
      'Ticari alacakların tahsil yöntemleri',
      'İcra takibine itiraz süreçleri',
      'İflas erteleme başvuruları',
      'Konkordato şartları ve süreci',
      'İhtiyati haciz şartları',
      'İcra takibinin durdurulması',
    ],
    howWeHelp: 'İcra ve iflas hukuku ekibimiz, müvekkillerimizin alacaklarının tahsili için en etkili yöntemleri belirleyerek hızlı ve sonuç odaklı çalışır. İcra takiplerinin başlatılmasından mahkeme süreçlerine kadar tüm aşamalarda müvekkillerimizi temsil ediyor, borçlu tarafta ise müvekkillerimizin haklarını koruyarak en uygun çözümleri üretiyoruz. Konkordato ve iflas süreçlerinde deneyimli ekibimizle stratejik danışmanlık sağlıyoruz.',
  },
  {
    id: 7,
    slug: 'international-trade-law',
    title: 'Uluslararası Ticaret Hukuku',
    shortDescription: 'Sınır ötesi ticari işlemlerde kapsamlı hukuki danışmanlık',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20international%20business%20meeting%20with%20world%20map%20and%20global%20trade%20documents%20on%20conference%20table%20professional%20corporate%20setting%20elegant%20office%20interior%20premium%20business%20photography&width=600&height=450&seq=pa7&orientation=landscape',
    fullDescription: 'Uluslararası ticaret hukuku pratiğimiz, sınır ötesi ticari işlemlerde, uluslararası sözleşmelerde ve ticari uyuşmazlıkların çözümünde müvekkillerimize stratejik hukuki danışmanlık sunmaktadır. Türkiye\'de faaliyet gösteren yabancı şirketlere ve yurt dışında iş yapan Türk şirketlerine kapsamlı destek sağlıyoruz.',
    services: [
      'Uluslararası ticari sözleşmeler',
      'İthalat ve ihracat düzenlemeleri',
      'Gümrük hukuku danışmanlığı',
      'Uluslararası tahkim',
      'Dış ticaret uyuşmazlıkları',
      'Akreditif ve ödeme yöntemleri',
      'Uluslararası taşıma sözleşmeleri',
      'Ticari temsilcilik ve distribütörlük',
    ],
    commonIssues: [
      'Uluslararası sözleşmelerde uygulanacak hukuk',
      'İthalat ve ihracat prosedürleri',
      'Gümrük vergileri ve düzenlemeleri',
      'Uluslararası ödeme yöntemleri ve riskleri',
      'Ticari uyuşmazlıklarda tahkim',
      'Yabancı mahkeme kararlarının tanınması',
    ],
    howWeHelp: 'Uluslararası ticaret hukuku uzmanlarımız, müvekkillerimizin küresel ticari faaliyetlerinde hukuki güvenlik sağlamak için kapsamlı danışmanlık hizmetleri sunar. Farklı hukuk sistemlerine hakim ekibimizle, uluslararası sözleşmelerin hazırlanmasından uyuşmazlıkların çözümüne kadar tüm süreçte müvekkillerimize rehberlik ederiz. Uluslararası tahkim süreçlerinde deneyimli avukatlarımızla müvekkillerimizi güçlü bir şekilde temsil ederiz.',
  },
  {
    id: 8,
    slug: 'investment-law',
    title: 'Yatırım Hukuku',
    shortDescription: 'Yerli ve yabancı yatırımcılara stratejik hukuki danışmanlık',
    icon: 'ri-line-chart-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20investment%20analysis%20with%20financial%20charts%20and%20documents%20on%20modern%20desk%20business%20growth%20graphs%20elegant%20corporate%20office%20setting%20premium%20financial%20photography%20natural%20lighting&width=600&height=450&seq=pa8&orientation=landscape',
    fullDescription: 'Yatırım hukuku pratiğimiz, Türkiye\'ye yatırım yapmak isteyen yabancı yatırımcılara ve yurt dışında yatırım yapan Türk şirketlerine kapsamlı hukuki danışmanlık sunmaktadır. Yatırım teşviklerinden yatırım koruma anlaşmalarına kadar geniş bir alanda hizmet veriyoruz.',
    services: [
      'Yabancı yatırım danışmanlığı',
      'Yatırım teşvikleri',
      'Yatırım koruma anlaşmaları',
      'Özelleştirme projeleri',
      'Kamu-özel işbirliği (PPP)',
      'Enerji yatırımları',
      'Yatırım uyuşmazlıkları',
      'Yatırım tahkimi',
    ],
    commonIssues: [
      'Yabancı yatırımcıların Türkiye\'deki hakları',
      'Yatırım teşvik belgesi başvuruları',
      'Yatırım koruma anlaşmalarının uygulanması',
      'Kamulaştırma ve tazminat',
      'Yatırım uyuşmazlıklarının çözümü',
      'Sektörel düzenlemeler ve izinler',
    ],
    howWeHelp: 'Yatırım hukuku ekibimiz, müvekkillerimizin Türkiye\'deki yatırımlarını güvence altına almak için kapsamlı hukuki inceleme ve danışmanlık hizmetleri sunar. Yatırım teşviklerinden yararlanma süreçlerinde rehberlik ediyor, yatırım koruma anlaşmalarının uygulanmasında stratejik destek sağlıyoruz. Yatırım uyuşmazlıklarında ise, uluslararası tahkim dahil tüm hukuki yolları kullanarak müvekkillerimizin haklarını koruyoruz.',
  },
  {
    id: 9,
    slug: 'family-law',
    title: 'Aile Hukuku',
    shortDescription: 'Boşanma, velayet ve miras konularında hassas ve profesyonel temsil',
    icon: 'ri-parent-line',
    image: 'https://readdy.ai/api/search-image?query=elegant%20private%20consultation%20room%20in%20law%20office%20with%20comfortable%20seating%20and%20warm%20lighting%20professional%20yet%20compassionate%20atmosphere%20modern%20interior%20design%20premium%20legal%20office%20photography&width=600&height=450&seq=pa9&orientation=landscape',
    fullDescription: 'Aile hukuku pratiğimiz, boşanma davalarından velayet uyuşmazlıklarına, nafaka davalarından miras hukukuna kadar aile hukukunun tüm alanlarında müvekkillerimize hassas ve profesyonel hukuki danışmanlık ve temsil hizmetleri sunmaktadır. Müvekkillerimizin duygusal ve hukuki ihtiyaçlarını anlayarak, en iyi sonuçları elde etmek için çalışıyoruz.',
    services: [
      'Boşanma davaları',
      'Velayet ve kişisel ilişki düzenleme',
      'Nafaka davaları',
      'Mal rejimi ve tasfiye',
      'Evlilik sözleşmeleri',
      'Nişanın bozulması',
      'Soybağı davaları',
      'Evlat edinme',
    ],
    commonIssues: [
      'Anlaşmalı ve çekişmeli boşanma süreçleri',
      'Çocukların velayeti ve ziyaret hakları',
      'Nafaka miktarının belirlenmesi',
      'Mal rejimi ve malların paylaşımı',
      'Yabancı unsurlu boşanma davaları',
      'Boşanma sonrası soyadı kullanımı',
    ],
    howWeHelp: 'Aile hukuku uzmanlarımız, müvekkillerimizin bu hassas dönemde yanında olarak, hem duygusal destek hem de güçlü hukuki temsil sağlar. Her vakanın benzersiz olduğunu bilerek, müvekkillerimizin ve çocuklarının çıkarlarını koruyacak özelleştirilmiş stratejiler geliştiririz. Anlaşmalı çözüm yollarını tercih ederken, gerektiğinde mahkemede müvekkillerimizi güçlü bir şekilde temsil ederiz.',
  },
  {
    id: 10,
    slug: 'criminal-law',
    title: 'Ceza Hukuku',
    shortDescription: 'Ceza davalarında güçlü savunma ve mağdur hakları temsili',
    icon: 'ri-shield-line',
    image: 'https://readdy.ai/api/search-image?query=serious%20criminal%20law%20courtroom%20with%20judges%20bench%20and%20legal%20setting%20professional%20judicial%20atmosphere%20traditional%20court%20interior%20with%20wooden%20panels%20premium%20legal%20photography%20natural%20lighting&width=600&height=450&seq=pa10&orientation=landscape',
    fullDescription: 'Ceza hukuku pratiğimiz, ceza davalarında sanık savunmasından mağdur haklarının korunmasına kadar geniş bir yelpazede hukuki danışmanlık ve temsil hizmetleri sunmaktadır. Ağır ceza davalarından kabahatler hukukuna, ekonomik suçlardan bilişim suçlarına kadar tüm ceza hukuku alanlarında uzmanız.',
    services: [
      'Ceza davalarında savunma',
      'Mağdur hakları temsili',
      'Soruşturma aşaması danışmanlığı',
      'Tutuklama ve tahliye talepleri',
      'İstinaf ve temyiz başvuruları',
      'Ekonomik suçlar',
      'Bilişim suçları',
      'Kabahatler hukuku',
    ],
    commonIssues: [
      'Ceza soruşturması ve kovuşturma süreçleri',
      'Tutuklama şartları ve itiraz yolları',
      'Sanık hakları ve savunma stratejileri',
      'Mağdur hakları ve tazminat talepleri',
      'Uzlaşma ve hükmün açıklanmasının geri bırakılması',
      'Ceza mahkemesi kararlarına itiraz',
    ],
    howWeHelp: 'Ceza hukuku ekibimiz, müvekkillerimizin özgürlük ve haklarını korumak için güçlü ve stratejik savunma hizmetleri sunar. Soruşturma aşamasından yargılama sürecine kadar tüm aşamalarda müvekkillerimizin yanında olur, en iyi hukuki sonuçları elde etmek için çalışırız. Mağdur tarafta ise, müvekkillerimizin haklarının tam olarak korunmasını ve tazminat taleplerinin karşılanmasını sağlarız.',
  },
];